import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TextGroup, TextTypes } from '../../components/index';
import moment from 'moment';
import CardMobile from '../../components/card-detail/card-mobile';
import { GiftCard, PaymentDetails } from '../../types/graphql-global-types';
import CardIcons from '../../components/card-icons';

interface OrderMobileProps {
    order: any;
    setBalance: (card: GiftCard) => Promise<void>;
    updateCardSchedule: (
        clientcardsrno: string,
        carddetid: number,
        shipdate: number,
    ) => Promise<void>;
}

const OrderMobile = ({ order, ...props }: OrderMobileProps) => {
    return (
        <Col>
            {order.paymentdetails?.map((payment: PaymentDetails) => {
                const { ipddate, ipdcctype } = payment;
                return (
                    <div className="payment" key={ipddate}>
                        <Row>
                            <TextGroup
                                label="Order Number"
                                value={order.orderno}
                                valueType={TextTypes.H4}
                            />
                            <TextGroup
                                label="Total Amount"
                                value={'$' + payment.ipdpcamt?.toFixed(2)}
                                valueType={TextTypes.H4}
                            />
                        </Row>
                        <Row>
                            <TextGroup
                                label="Date"
                                value={moment(moment.utc(ipddate)).local().format('MM/DD/YYYY')}
                            />
                            <TextGroup
                                label="Time"
                                value={moment(moment.utc(ipddate)).local().format('hh:mm A')}
                            />
                        </Row>
                        <Row>
                            <TextGroup label="Billed to" value={order.sendername} />
                            <TextGroup
                                label="Card Type"
                                value={
                                    <span>
                                        {CardIcons[ipdcctype || ''] || ipdcctype}
                                        &nbsp;&nbsp; {payment.ipdpcnoquad?.slice(-4)}
                                    </span>
                                }
                            />
                        </Row>
                    </div>
                );
            })}
            {order.lineitems?.map((card: GiftCard) => (
                <CardMobile
                    key={card.lineitemid}
                    card={card}
                    lineitems={order.lineitems}
                    setBalance={props.setBalance}
                    updateCardSchedule={props.updateCardSchedule}
                />
            ))}
        </Col>
    );
};

export default OrderMobile;
